const StepContainer = ({ children }) => {
  return (
    <div className="bg-background rounded-xl p-6">
      {children}
    </div>
  );
};

export default StepContainer; 